import React from 'react';
import {
  ThumbnailViewGrayIcon,
  ListViewGrayIcon,
  ThumbnailViewWhiteIcon,
  ListViewWhiteIcon,
} from 'asset/images';
import { makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';
import { style, ViewMode } from 'commons/constants/KeyFlowConstants';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '167px',
    border: '1px solid #b4b4b4',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
    },
  },
  labelContainer: {
    flexGrow: 1,
    display: 'inline-block',
    padding: '0 15px 0 15px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  iconContainer: {
    flexGrow: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '32px',
    textAlign: 'center',
    height: '100%',
    '& > img': {
      // height: '60%',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  isActive: {
    backgroundColor: '#D94F98',
  },
}));

function SquareSwitch({ onChange, value }: SwitchProps) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <span className={classes.labelContainer}>결과뷰전환</span>
      <span
        className={clsx(classes.iconContainer, value === ViewMode.THUMBNAIL && classes.isActive)}
        onClick={onChange}
      >
        {value === ViewMode.THUMBNAIL ? (
          <img src={ThumbnailViewWhiteIcon}></img>
        ) : (
          <img src={ThumbnailViewGrayIcon}></img>
        )}
      </span>
      <span
        className={clsx(classes.iconContainer, value === ViewMode.LIST && classes.isActive)}
        onClick={onChange}
      >
        {value === ViewMode.LIST ? (
          <img src={ListViewWhiteIcon}></img>
        ) : (
          <img src={ListViewGrayIcon}></img>
        )}
      </span>
    </div>
  );
}

export default SquareSwitch;
